import { useEffect } from 'react'
import { useAuthStore } from '../stores/auth'
import { api } from '../lib/api'
import type { UserDto } from '@emag/shared'

/**
 * La montare: dacă nu avem access token, încearcă refresh (cookie httpOnly).
 * Dacă reușește, încarcă /me. Setează `initialized` la final indiferent de rezultat.
 */
export function useBootstrapAuth(): void {
  const initialized = useAuthStore((s) => s.initialized)

  useEffect(() => {
    if (initialized) return
    let cancelled = false
    ;(async () => {
      try {
        const token = useAuthStore.getState().accessToken
        if (!token) {
          const res = await api.post<{ accessToken: string }>('/auth/refresh')
          if (cancelled) return
          useAuthStore.getState().setAccessToken(res.data.accessToken)
        }
        const me = await api.get<{ user: UserDto }>('/auth/me')
        if (cancelled) return
        useAuthStore.getState().setUser(me.data.user)
      } catch {
        if (!cancelled) useAuthStore.getState().clear()
      } finally {
        if (!cancelled) useAuthStore.getState().setInitialized(true)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [initialized])
}
